const Activity = () => import('@pages/activity/Activity')
const ActivitySelect = () => import('@pages/activity/ActivitySelect')
const ActivityPaid = () => import('@pages/activity/ActivityPaid')

export const activity = [
  {
    path: '/activity/Activity/',
    name: 'Activity',
    component: Activity,
    meta: {}
  },
  {
    path: '/activity/ActivitySelect',
    name: 'ActivitySelect',
    component: ActivitySelect,
    meta: {}
  },
  {
    path: '/activity/ActivityPaid',
    name: 'ActivityPaid',
    component: ActivityPaid,
    meta: {}
  }

]



// WEBPACK FOOTER //
// ./src/router/mod/activity.route.js